import { render, staticRenderFns } from "./CardTemplateMarket.vue?vue&type=template&id=a8207a56&scoped=true&"
import script from "./CardTemplateMarket.vue?vue&type=script&lang=js&"
export * from "./CardTemplateMarket.vue?vue&type=script&lang=js&"
import style0 from "./CardTemplateMarket.vue?vue&type=style&index=0&id=a8207a56&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8207a56",
  null
  
)

export default component.exports